export default __webpack_public_path__ + "static/media/upload_suceeded.9ab0e4bd.svg";